export function renameObjKey (o, _old, _new) {
  if (_old !== _new && o.hasOwnProperty(_old)) {
    Object.defineProperty(o, _new, Object.getOwnPropertyDescriptor(o, _old))
    delete o[_old]
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/rename-key.js